<ul class="quote-list">
  <li *ngFor="let quote of quotes" [@highlightNew]="quote.recent ? 'recent' : 'default'">
    <button class="btn btn-primary "  type="button" mdbWavesEffect (click)="onQuoteClick(quote, $event)">📝 <small>{{ quote.quoteId }} {{ quote.loanStatus }} - ID number: {{quote.idNumber}}</small></button>
  </li>
</ul>
